import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[onlyNumber]'
})
export class OnlyNumberDirective {

    /**
     * Com atributo bare `onlyNumber`, o Angular liga string vazia — trata como ativo.
     * Use [onlyNumber]="false" para desligar.
     */
    @Input('onlyNumber') onlyNumber: boolean | string = true;

    constructor(private el: ElementRef) { }

    private isEnabled(): boolean {
        return this.onlyNumber !== false && this.onlyNumber !== 'false';
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (!this.isEnabled()) {
            return;
        }

        const e = event;
        const keyCode = e.keyCode;

        // Allow: backspace, delete, tab, escape, enter, decimal (numpad + . + ,)
        if ([46, 8, 9, 27, 13, 110, 190, 188].indexOf(keyCode) !== -1 ||
            // Allow: Ctrl/Cmd+A, C, V, X
            (keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
            (keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
            (keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
            (keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
            // Allow: home, end, left, right
            (keyCode >= 35 && keyCode <= 39)) {
            return;
        }

        // Block non-numeric (top row 0-9 and numpad 0-9)
        if ((e.shiftKey || (keyCode < 48 || keyCode > 57)) && (keyCode < 96 || keyCode > 105)) {
            e.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        if (!this.isEnabled()) {
            return;
        }

        const pasted = event.clipboardData?.getData('text') ?? '';
        // Permite dígitos, ponto e vírgula (percentual BR)
        if (!/^[0-9.,]*$/.test(pasted)) {
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event'])
    onInput(): void {
        if (!this.isEnabled()) {
            return;
        }

        const input = this.el.nativeElement as HTMLInputElement;
        const cleaned = String(input.value ?? '').replace(/[^0-9.,]/g, '');
        if (cleaned !== input.value) {
            input.value = cleaned;
        }
    }
}
